'use strict';
var TrackingAction;
(function (TrackingAction) {
    TrackingAction["Select"] = "select";
    TrackingAction["Abandon"] = "abandon";
    TrackingAction["Search"] = "search";
})(TrackingAction || (TrackingAction = {}));
export default TrackingAction;
